import type { ExclusionAreaObservationComment } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapSingle } from '../normalize'

export const addComment = async ({
  observationId,
  message,
}: {
  observationId: string
  message: string
}): Promise<ExclusionAreaObservationComment> => {
  const response = await apiClient.post(
    endpoints.v2.exclusionAreaObservations.comments(observationId),
    { message },
  )
  return unwrapSingle<ExclusionAreaObservationComment>(response)
}
